import React, {Component, PropTypes} from 'react';
import { RequiredLabel, InlineWarning, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './simple-text-element.style.js';

export class SimpleTextElement extends Component {

  render() {
    const { maxLength, isRequired, label, id, response, defaultValue, onChange, disabled, readOnly, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);
    const value = response === undefined ? !defaultValue ? "" : defaultValue : response;
    const maxLengthId = id + '-maxLength';

    return (
      <div className={css.group}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          isRequired={isRequired}
          css={{requiredLabel: css.label}}/>
          <div className={css.displayWrapper}>
            <input
              id={id}
              type="text"
              maxLength={maxLength}
              onChange={e => onChange(e.target.value)}
              disabled={disabled}
              readOnly={readOnly}
              className={css.text}
              aria-required={isRequired}
              aria-invalid={hasErrors && showErrors}
              aria-describedby={errorIds + ' ' + maxLengthId}
              value={value}/>
            <span id={maxLengthId} className="skip">{maxLength ? maxLength + ' characters max' : '' }</span>
            {inlineErrors && inlineErrors.map(warn => (
              <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
            ))}
          </div>
      </div>
    );
  }
}

SimpleTextElement.propTypes = {
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool,
};

export default styleable(defaultStyle) (SimpleTextElement);



// WEBPACK FOOTER //
// src/common/form-elements/simple-text-element-folder/simple-text-element.js